export class ResourcesService {
    items;
    filterProviders;

    constructor() {
        this.filterProviders = [];
        this.items = {};
    }

    addFilterProvider(filterProvider) {
        this.filterProviders.push(filterProvider);
    }

    cancelAll() {
        Object.values(this.items).forEach((request) => {
            request.abort();
        });
    }

    cancelByHash(request) {
        if (request.method !== 'GET') {
            return;
        }

        let hash = this.hash(request.url);

        if (this.items[hash]) {
            this.items[hash].abort();
            delete this.items[hash];

            return true;
        }

        return false;
    }

    collect(request) {
        if (!request || this.filter(request.url)) {
            return;
        }

        let hash = this.hash(request.url);
        this.items[hash] = request;
    }

    filter(url) {
        let result = false;
        this.filterProviders.forEach(filterProvider => {
            result = filterProvider.filter(url);

            if (result) {
                return false;
            }
        });

        return result;
    }

    hash(str) {
        if (!str) {
            return '';
        }

        let length = str.length, res = [];
        while (length--) {
            res.push(str.charCodeAt(length));
        }

        return res.join('');
    }
}


// WEBPACK FOOTER //
// ./src/services/resources/ResourcesService.js